import { I as o } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCloudMoonRain",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(o).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return o[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.016 2.702a2.5 2.5 0 0 0-1.482 1.881.5.5 0 1 1-.985-.166A3.501 3.501 0 0 1 7.999 1.5a.5.5 0 0 1 .36.849 1.621 1.621 0 0 0 2.292 2.293A.5.5 0 0 1 11.5 5a3.498 3.498 0 0 1-1.75 3.031.5.5 0 1 1-.5-.865c.466-.27.836-.685 1.05-1.183a2.621 2.621 0 0 1-3.284-3.281Z",
  fill: "currentColor"
}, null, -1), _ = /* @__PURE__ */ e("path", {
  d: "M3.552 6.502A2 2 0 0 0 1.9 9.7a.5.5 0 1 1-.8.6 3 3 0 0 1 4.79-3.614c.188.248.32.814.32.814s.134.65-.386.65c-.168 0-.608.037-.608-.559 0-.596-.915-1.09-1.664-1.09Z",
  fill: "currentColor"
}, null, -1), m = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.5 9.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Zm-2-.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), f = [
  u,
  _,
  m
];
function h(t, p, i, v, C, a) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--cloud-moon-rain"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Cloud Moon Rain",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 10, c);
}
const M = /* @__PURE__ */ n(s, [["render", h]]);
export {
  M as default
};
//# sourceMappingURL=cloud-moon-rain.js.map
